import React from 'react';
import {
  DocumentIcon,
  ImageIcon,
  ItemBinderIcon,
  LinkIcon,
  PresentationIcon,
  VideoIcon,
  WebsiteLinkIcon,
} from 'src/images';
import { isVideoUrl } from 'shared/utils';
import { KNOWLEDGE_TYPES } from 'shared/constants';
import styles from './item-type.module.scss';

const TYPE_TO_ICON_MAPPER = {
  content: DocumentIcon,
  pdf: DocumentIcon,
  excel: DocumentIcon,
  document: DocumentIcon,
  image: ImageIcon,
  video: VideoIcon,
  presentation: PresentationIcon,
  link: LinkIcon,
  'external-link': WebsiteLinkIcon,
};

export function ItemType({ type, link, className }) {
  const isVideo = link && isVideoUrl(link);
  const Icon = isVideo
    ? TYPE_TO_ICON_MAPPER[KNOWLEDGE_TYPES.VIDEO]
    : TYPE_TO_ICON_MAPPER[type] || ItemBinderIcon;

  return <img src={Icon} className={className || styles.icon} alt={`${type}-knowledge-item`} />;
}
